import {
    FETCH_ADVERTISEMENT,
    RESET_ADVERTISEMENT,
  } from "../../constants/action.constants";
  
  const initialState = {
    data: {},
  };
  
  const advertisementViewReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ADVERTISEMENT:
        return { data: action.payload, others: action.others };
      case RESET_ADVERTISEMENT:
        return initialState;
      default:
        return state;
    }
  };
  
  export default advertisementViewReducer;
  